module.exports = __webpack_public_path__ + "media/images/banner/japanesecrafts/vi-4256dbc70516242d87e2f37db48cc3da.png";